<div class="section-intro">
  <ng-content></ng-content>
</div>
